import { ReportTypeSlideConfig } from '../constants/report-type-slide-config.const';
import { ReportType, ReportTypes } from '../constants/report-type.const';
import { ReportSlide, ReportSlideKey } from '../interfaces';
import {
	getSlideHeadingDefaults,
	ReportSlideHeadingContext,
} from './slide-heading.utils';

/**
 * Creates a single report slide. Slides are agnostic and reusable across report types.
 * Header copy is stored on the slide so a report can rename it later.
 */
export const createReportSlide = (
	key: ReportSlideKey,
	context?: ReportSlideHeadingContext,
): ReportSlide => {
	const headings = getSlideHeadingDefaults(key, context);
	return {
		key,
		enabled: true,
		content: [],
		header: headings.header,
		subheader: headings.subheader,
		showSubheader: headings.showSubheader,
	};
};

/**
 * Creates report slides for a specific report type.
 * Uses the report type configuration to determine which slides to create and their order.
 */
export const createReportSlidesForType = (
	reportType: ReportType,
	context?: Omit<ReportSlideHeadingContext, 'reportType'>,
): ReportSlide[] =>
	ReportTypeSlideConfig[reportType].map((key) =>
		createReportSlide(key, { ...context, reportType }),
	);

/**
 * Returns an order map for the given report type.
 * Used when sorting slides fetched from the database.
 */
export const getReportSlideOrderMap = (
	reportType: ReportType,
): Map<ReportSlideKey, number> =>
	new Map(
		ReportTypeSlideConfig[reportType].map((key, index) => [key, index]),
	);

/**
 * @deprecated Use getReportSlideOrderMap(reportType) instead for report-type-aware ordering.
 * Kept for backwards compatibility. Order map for 80/20 report type.
 */
export const ReportSlideOrderMap = getReportSlideOrderMap(
	ReportTypes.EightyTwenty,
);

export const MaxContentLength = 2500;
